export default {
  paged: {
    select: 'id,name,description',
    searchSelect: ['name', 'description'],
  },
  item: {
    select: 'id,name,description',
  },
  itemDetail: {
    select: 'id,name,description,created,updated,creator,modifier',
  },
};
